import React from "react";
import AttributeHeader from "./gridCells/AttributeHeader";
import { RuleModuleType } from "../constants/constants";

interface Props {
  ruleModuleType: RuleModuleType;
  name: string;
  newForm?: JSX.Element | undefined;
  testKey: string;
  adminMode?: boolean;
}

const RankBonusGrid: React.FC<Props> = ({
  ruleModuleType,
  name,
  newForm,
  testKey,
  adminMode = false,
  children,
}) => {
  let className = "grid-simple";
  switch (ruleModuleType) {
    case RuleModuleType.RankAndSource:
    case RuleModuleType.RankOnly:
      className = "grid-bonus";
      break;
    case RuleModuleType.SelectOnly:
      className = "";
  }

  const headerId = `header-key-${testKey}`;
  return (
    <div
      key={`key-${testKey}`}
      className={`grid-container grid-container-width ${className}`}
      data-test={`rank-grid-${testKey}`}
    >
      <AttributeHeader
        key={headerId}
        dataTest={headerId}
        ruleModuleType={ruleModuleType}
        name={name}
        adminMode={adminMode}
      />
      {children}
      {newForm}
    </div>
  );
};

export default RankBonusGrid;
